import { supabase } from '../../infrastructure/supabase/supabaseClient';

export class AuthService {
  /**
   * Inicia sesión o registra al usuario utilizando Google OAuth 2.0.
   * Esto redirigirá a la pantalla de Google para validación.
   */
  static async signInWithGoogle() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: globalThis.window?.location?.origin,
      }
    });
    if (error) throw error;
    return data;
  }

  /**
   * (NUEVO) Inicia sesión usando OTP enviado por correo electrónico (Magic Link / Código de 6 dígitos)
   */
  static async signInWithOtp(email: string) {
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        shouldCreateUser: true, // Registra si no existe
        emailRedirectTo: globalThis.window?.location?.origin,
      }
    });
    if (error) throw error;
    return data;
  }

  /**
   * (NUEVO) Verifica el código OTP de 6 dígitos enviado al correo
   */
  static async verifyOtp(email: string, token: string) {
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token,
      type: 'email'
    });
    if (error) throw error;
    return data;
  }

  /**
   * Iniciar sesión con Passkey (WebAuthn).
   * Llama a la API nativa de Supabase para passwordless WebAuthn.
   */
  static async signInWithPasskey() {
    // Si supabase.auth.signInWithPasskey existe, lo usamos (v2 reciente)
    if (typeof (supabase.auth as any).signInWithPasskey === 'function') {
      const { data, error } = await (supabase.auth as any).signInWithPasskey();
      if (error) throw error;
      return data;
    } else {
      throw new TypeError('La versión actual de Supabase JS no soporta signInWithPasskey de forma nativa.');
    }
  }

  /**
   * Inscribe un Passkey nuevo al usuario actual.
   * Se ejecuta DESPUÉS de que el usuario ya está logueado por otro medio (ej: OTP o Google).
   */
  static async enrollPasskey() {
    throw new Error('Pendiente de implementación de interfaz de enrollPasskey con Supabase UI o Custom Auth.');
  }

  /**
   * Cierra la sesión actual.
   */
  static async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  }

  /**
   * Obtiene la sesión actual.
   */
  static async getSession() {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  }
}

